import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { SpezifikationsArtActions, SpezifikationsArtActionTypes } from '../../actions/mdqx/spezifikations-art.actions';
import { SpezifikationsArtEntity } from '../../../entities/mdqx/spezifikations-art.entity';

export interface SpezifikationsArtState extends EntityState<SpezifikationsArtEntity> {
    fetched: boolean;
}

export const SPEZIFIKATIONSART_KEY = 'spezifikationsArt';

const adapter = createEntityAdapter<SpezifikationsArtEntity>({
    selectId: spezifikationsArt => spezifikationsArt.Id,
});

const initialState: SpezifikationsArtState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function spezifikationsArtReducer(state = initialState, action: SpezifikationsArtActions) {
    switch (action.type) {
        case SpezifikationsArtActionTypes.GetSpezifikationsArtenResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllSpezifikationsArten = selectAll;

export const selectSpezifikationsArtenFetched = (state: SpezifikationsArtState) => state.fetched;
